import getCookie from "./getCookie";

/**
 * Reads the Google Ads click id (gclid) captured by the inline script in the page
 * template (public/Index.cshtml and public/index.html).
 *
 * Falls back to the 90-day `gclid` cookie that script sets, so the value still
 * resolves after the visitor has navigated away from the ad landing page.
 *
 * @returns {string} The gclid, or an empty string when there isn't one.
 */
function getGclid() {
    try {
        const field = document.getElementById("zc_gad");
        if (field && field.value) return field.value;
        return getCookie("gclid") || "";
    } catch (e) {
        return "";
    }
}

export default getGclid;
